import React, { useState, useEffect } from 'react';
import layerLibrary from '../canvas/LayerLibrary';
import AddIcon from '@mui/icons-material/Add';
import DownloadIcon from '@mui/icons-material/Download';
import UploadIcon from '@mui/icons-material/Upload';
import SortByAlphaIcon from '@mui/icons-material/SortByAlpha';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import FlipIcon from '@mui/icons-material/Flip';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import NewLayerModal from '../components/NewLayerModal'; 
import LayersIcon from '@mui/icons-material/Layers';
import axios from 'axios';
import DeleteIcon from '@mui/icons-material/Delete';


const LayerTab = () => {
  const [expandedGroups, setExpandedGroups] = useState({});
  const [_, forceUpdate] = useState(0);
  const [search, setSearch] = useState('');
  const [grouped, setGrouped] = useState(false);
  const [dragIndex, setDragIndex] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showUsedOnly, setShowUsedOnly] = useState(false);



  const layers = layerLibrary.getAllLayers();
  const groupedLayers = layerLibrary.getGroupedLayers();

  useEffect(() => {
   (async () => {
     await layerLibrary.ensureLoaded();
     forceUpdate(p => p + 1);
   })();
 }, []);



const handleSaveLayer = async (newLayer) => {
  const token = localStorage.getItem("access_token");
  try {
    const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/layers/user/layers`, {
      layers: [...layerLibrary.getAllLayers(), newLayer]
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    await layerLibrary.loadUserLayers(); // reload updated list
    forceUpdate(p => p + 1);
  } catch (err) {
    console.error("❌ Failed to save layer:", err);
  }
};


const handleDelete = async () => {
  const selected = layerLibrary.getSelectedLayers();
  if (selected.length === 0) {
    alert("⚠️ No layer selected to delete.");
    return;
  }
  if (!window.confirm("Are you sure you want to delete the selected layer(s)?")) return;

  await layerLibrary.deleteSelectedLayers(); // 🔥 call delete
  forceUpdate(p => p + 1);                   // re-render
};


  const toggleGroup = (groupName) => {
    setExpandedGroups((prev) => ({
      ...prev,
      [groupName]: !prev[groupName],
    }));
  };

  const toggleVisibility = (layer) => {
    layerLibrary.toggleVisibility(layer);
    forceUpdate((p) => p + 1);
  };

  const toggleLock = (layer) => {
    layerLibrary.toggleLock(layer);
    forceUpdate((p) => p + 1);
  };

  // Toggle edit mode for a layer
  // LayerPanel.jsx
const toggleEdit = async (layer) => {
  if (layerLibrary.isEditing(layer)) {
    const { edit_name, edit_dtype, edit_number, edit_dtypenum } = layer;

    let duplicate = false;
    if (layerLibrary.checkEditLayer(layer)) {
      duplicate = layerLibrary.isDuplicate1(layer) || layerLibrary.isDuplicate2(layer);
    }
    if (duplicate) {
      alert('❌ Duplicate layer properties are not allowed.');
      layerLibrary.toggleEdit(layer);
      return;
    }

    const updated = {
      layer_name: edit_name,
      layer_number: edit_number,
      datatype_name: edit_dtype,
      datatype_number: edit_dtypenum,
    };

    // ⬇️ persist to backend
    await layerLibrary.updateLayer(layer, updated);

    // (optional) backend se fresh list laa lo, agar number/dtype badle ho:
    // await layerLibrary.loadUserLayers();   // :contentReference[oaicite:3]{index=3}

  } else {
    layer.edit_name = layer.layer_name;
    layer.edit_number = layer.layer_number;
    layer.edit_dtype = layer.datatype_name;
    layer.edit_dtypenum = layer.datatype_number;
  }

  layerLibrary.toggleEdit(layer);
  forceUpdate(p => p + 1);
};


  


  const handleExportLayers = () => {
  const layers = layerLibrary.getAllLayers();

  const json = JSON.stringify({ layers }, null, 2); // Pretty JSON

  const blob = new Blob([json], { type: 'application/json' });
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = 'layer_export.json';
  a.click();

  URL.revokeObjectURL(url); // Clean memory
};


const handleImportLayers = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  try {
    const text = await file.text();
    const json = JSON.parse(text);

    if (!json.layers || !Array.isArray(json.layers)) {
      alert("❌ Invalid file format. Expected 'layers' array.");
      return;
    }

    // 1️⃣ Update local state
    layerLibrary.setLayers(json.layers);

    // 2️⃣ Save to backend
    const token = localStorage.getItem("access_token");
    await axios.post(`${process.env.REACT_APP_API_BASE_URL}/layers/user/layers`, json, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    alert("✅ Layers imported & saved.");
    forceUpdate(p => p + 1);
  } catch (err) {
    console.error("❌ Import error:", err);
    alert("Import failed: " + err.message);
  }
};


  
  const handleEditInput = (layer, field, value) => {
    layer[field] = value;
    forceUpdate((p) => p + 1);
  };

  const IconButton = ({ icon:Icon, title, onClick }) => (
    <button
      title={title}
      onClick={onClick}
      style={{
        backgroundColor: '#2b2b2b',
        color: '#fff',
        border: '1px solid #444',
        borderRadius: '5px',
        paddingLeft:'2px',
        paddingRight:'2px',
        marginBottom: '2px',
        fontSize: '10px',
        marginRight: '2px',
        // marginBottom: '3px',
        cursor: 'pointer',
      }}
    >
      <Icon style={{ fontSize: '16px' }} />
    </button>
  );

  const renderLayerRow = (layer, i) => {
    const visible = layerLibrary.isLayerVisible(layer.layer_number, layer.datatype_number);
    const locked = layerLibrary.isLayerLocked(layer.layer_number, layer.datatype_number);
    const editing = layerLibrary.isEditing(layer);
    const isSelected = layerLibrary.isLayerSelected(layer);

  
    return (
      <div
        key={i}
        style={{
            ...layerBoxStyle,
            opacity: isSelected ? 0.5 : 1, // 👈 fade if selected
            border: isSelected ? '1px solid #00d8ff' : '1px solid #444', // Optional border
            cursor: 'pointer',
        //     height: editing ? 'auto' : '40px', // Expand height when editing
        // padding: editing ? '12px' : '8px 10px', // Add padding when expanded
        // transition: 'all 0.3s ease', // Smooth transition
        // backgroundColor: editing ? '#333' : '#2b2b2b', // Highlight when editing
        // flexDirection: editing ? 'column' : 'row', // Adjust layout for editing

        transition: 'all 0.3s ease', // Smooth transition
        backgroundColor: editing ? '#333' : '#2b2b2b', // Highlight when editing
        width: editing ? '99%' : '99%', // Increase width when editing
        alignSelf: editing ? 'center' : 'flex-start', // Center the row when editing
          }}

          onClick={(e) => {
            layerLibrary.selectLayer(layer, e.ctrlKey);
            forceUpdate(p => p + 1);
          }}
          
        draggable
        onDragStart={() => setDragIndex(i)}
        onDragOver={(e) => e.preventDefault()}
        
        onDrop={() => {
          if (dragIndex !== null && dragIndex !== i) {
            layerLibrary.reorder(dragIndex, i);
            forceUpdate((p) => p + 1);
          }
        }}
      >
        {/* Color Box */}
        <div
          style={{
            width: '14px',
            height: '14px',
            backgroundColor: layer.color,
            borderRadius: '4px',
            border: '1px solid #444',
            marginRight: '4px',
            marginTop: '2px',
            flexShrink: 0,
          }}
          title={`Layer Name: ${layer.layer_name}
Datatype Name: ${layer.datatype_name}
Layer Number: ${layer.layer_number}
Datatype Number: ${layer.datatype_number}`.trim()} // Tooltip with layer details
        ></div>
  
        {/* Info or Editable Fields */}
        <div style={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
        {editing ? (
  <div style={{
    display: 'grid',
    gridTemplateColumns: '50px 50px 30px 30px',
    gap: '1px',
    width: '100%'
  }}>
    <style>
    {`
      input[type=number]::-webkit-inner-spin-button,
      input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
      input[type=number] {
        -moz-appearance: textfield;
      }
    `}
  </style>
    <input
      type="text"
      value={layer.edit_name}
      onChange={(e) => handleEditInput(layer, 'edit_name', e.target.value)}
      style={inputStyle}
      placeholder="Name"
    />
    <input
      type="text"
      value={layer.edit_dtype}
      onChange={(e) => handleEditInput(layer, 'edit_dtype', e.target.value)}
      style={inputStyle}
      placeholder="DType"
    />
    {/* <input
      type="text"
      value={layer.edit_number}
      onChange={(e) => handleEditInput(layer, 'edit_number', e.target.value)}
      style={inputStyle}
      placeholder="L#"
    />
    <input
      type="text"
      value={layer.edit_dtypenum}
      onChange={(e) => handleEditInput(layer, 'edit_dtypenum', e.target.value)}
      style={inputStyle}
      placeholder="DT#"
    /> */}
    <input
  type="number"
  min="0"
  value={layer.edit_number}
  onChange={(e) => {
    const value = e.target.value;
    if (value === '' || Number(value) >= 0) {
      handleEditInput(layer, 'edit_number', value);
    }
  }}
  style={{
    ...inputStyle,
    // 👇 hide spinner arrows
    MozAppearance: 'textfield',
  }}
  placeholder="L#"
/>

<input
  type="number"
  min="0"
  value={layer.edit_dtypenum}
  onChange={(e) => {
    const value = e.target.value;
    if (value === '' || Number(value) >= 0) {
      handleEditInput(layer, 'edit_dtypenum', value);
    }
  }}
  style={{
    ...inputStyle,
    MozAppearance: 'textfield',
  }}
  placeholder="DT#"
/>

  </div>
          ) : (
            <div style={{
                display: 'grid',
                gridTemplateColumns: '45px 55px 29px 22.5px',
                gap: '2px',
                fontSize: '12px',
                fontWeight: 'bold',
                width: '100%'
              }}>
              

  <div title={layer.layer_name}>{truncateText(layer.layer_name, 3)}</div>
  <div title={layer.datatype_name}>{truncateText(layer.datatype_name, 2)}</div>
  <div title={layer.layer_number.toString()}>{truncateText(layer.layer_number.toString(), 2)}</div>
  <div title={layer.datatype_number.toString()}>{truncateText(layer.datatype_number.toString(), 2)}</div>
</div>

          )}
        </div>
  
        {/* Icons with reduced size */}
        <div style={{ display: 'flex', gap: '0px', alignItems: 'center',gap:'2px',minWidth: '80px',}}>
          <button
            onClick={() => toggleVisibility(layer)}
            style={{
              backgroundColor: visible ? '#2b2b2b' : '#2b2b2b',
              border: 'none',
              borderRadius: '4px',
              width: '16px',
              height: '16px',
              padding: '2px 1px',  // Reduced padding
              cursor: 'pointer',
              fontSize: '10px',  // Reduced font size
              color: '#fff',
            }}
            title="Toggle visibility"
          >
            {visible ? <VisibilityIcon style={{ color: 'white', fontSize:'15px'}} /> : <VisibilityOffIcon style={{ color: 'white', fontSize:'15px'}} />}
          </button>
  
          <button
            onClick={() => toggleLock(layer)}
            style={{
              backgroundColor: locked ? '#2b2b2b' : '#2b2b2b',
              border: 'none',
              borderRadius: '4px',
              width: '16px',
              height: '16px',
              padding: '1px 1px',  // Reduced padding
              cursor: 'pointer',
              fontSize: '10px',  // Reduced font size
              color: '#fff',
            }}
            title="Toggle lock"
          >
            {locked ?<LockIcon style={{ color: 'green', fontSize: '16px' }} /> : <LockOpenIcon style={{ color: 'white', fontSize: '16px' }} />
          }
          </button>
          <button
            onClick={() => toggleEdit(layer)}
            style={{
              backgroundColor: editing ? '#2b2b2b' : '#2b2b2b',
              border: 'none',
              borderRadius: '4px',
              width: '16px',
              height: '16px',
              padding: '2px 2px',  // Reduced padding
              cursor: 'pointer',
              fontSize: '10px',  // Reduced font size
              color: '#fff',
            }}
            title="Edit layer"
          >
            {editing ? <SaveIcon style={{ fontSize: '14px', color:'white'}} />:<EditIcon style={{ fontSize: '14px', color:'white' }} />}
          </button>
        </div>
      </div>
    );
  };
  
  
  

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      

      {/* 🔧 CONTROL ICON BAR */}
      <div style={iconBarStyle}>
    <IconButton icon={AddIcon} title="Add Layer" onClick={() => setShowModal(true)} />
    <IconButton icon={DownloadIcon} title="Export Layers" onClick={handleExportLayers} />
    <IconButton
  icon={UploadIcon}
  title="Import Layers"
  onClick={() => document.getElementById('layerImportInput').click()}
/>
<input
  id="layerImportInput"
  type="file"
  accept=".json"
  onChange={handleImportLayers}
  style={{ display: 'none' }}
/>

    <IconButton icon={SortByAlphaIcon} title="Sort by Name" onClick={() => { layerLibrary.setSortMode('name'); forceUpdate(p => p + 1); }} />
    <IconButton icon={FormatListNumberedIcon} title="Sort by Number" onClick={() => { layerLibrary.setSortMode('number'); forceUpdate(p => p + 1); }} />
    <IconButton icon={VisibilityIcon} title="Show All" onClick={() => {
                  layerLibrary.showAll();
                  forceUpdate(p => p + 1);
                    }} 
    />
    <IconButton icon={VisibilityOffIcon} title="Hide All" onClick={() => {
              layerLibrary.hideAll();
              forceUpdate(p => p + 1);
              }} 
      />
    <IconButton icon={LockIcon} title="Lock All" onClick={() => {
      layerLibrary.lockAll();
      forceUpdate(p => p + 1);
    }} />
    <IconButton icon={LockOpenIcon} title="Unlock All" onClick={() => {
      layerLibrary.unlockAll();
      forceUpdate(p => p + 1);
    }} />
      <IconButton icon={DeleteIcon} title="Delete Layer(s)" onClick={handleDelete} />

  <input
    type="color"
    onChange={(e) => {
      const selected = layerLibrary.getSelectedLayers();
      selected.forEach(layer => layerLibrary.updateColor(layer, e.target.value));
      forceUpdate(p => p + 1);
    }}
    style={{
      marginLeft: '2px',
      marginTop: '0px',
      marginRight: '4px',
      width: '20px', // Reduced width
      height: '20px', // Adjust height to match
      borderRadius: '1px',
      cursor: 'pointer',
      border:'none',
      WebkitAppearance: 'none',
    }}
    title='color picker'
  />
  {/* <label style={{ color: '#aaa', fontSize: '12px',display:'flex',alignItems:'center'}}>Opacity</label> */}
  <input
  type="range"
  min="0.1"
  max="1"
  step="0.1"
  value={
    layerLibrary.getSelectedLayers()?.[0]?.pattern?.opacity || 1
  }
  onChange={(e) => {
    const selected = layerLibrary.getSelectedLayers();
    selected.forEach(layer => layerLibrary.updateOpacity(layer, parseFloat(e.target.value)));
    forceUpdate(p => p + 1);
  }}
  style={{
    width: '90px',
    marginLeft: '2px',
    marginTop: '0px',
    marginRight: '4px',
    cursor: 'pointer',
    backgroundColor: '#444',
    borderRadius: '2px',
    border: 'none',
    verticalAlign: 'middle'   // ✅ keep aligned
  }}
  title='Opacity'
/>

  <IconButton icon={FlipIcon} title="Invert Visibility" onClick={() => {}} />
  <IconButton icon={GroupWorkIcon} title="Toggle Grouping" onClick={() => setGrouped(prev => !prev)} />
    <IconButton 
  icon={LayersIcon} 
  title="Show Used Layers Only" 
  onClick={() => setShowUsedOnly(prev => !prev)} 
/>
      </div>
      {/* 🔎 SEARCH FIELD */}
      <input
        type="text"
        placeholder="Search..."
        style={searchStyle}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {/* 📦 LAYER VIEW */}
      <div style={{ flex: 1,overflowY:'auto', overflowX:'hidden' ,width: '109%'}}>
      {/* {grouped ? (
        Object.entries(groupedLayers).map(([groupName, layers], index) => (
          <div key={index} style={{ marginBottom: '10px' }}>
            <div
              onClick={() => toggleGroup(groupName)}
              style={{
                backgroundColor: '#333',
                padding: '10px',
                cursor: 'pointer',
                fontWeight: 'bold',
                borderRadius: '6px 6px 0 0',
                userSelect: 'none',
              }}
            >
              {expandedGroups[groupName] ? '▼' : '▶'} {groupName}
            </div>

            {expandedGroups[groupName] &&
              layers
                .filter((layer) =>
                  layer.layer_name.toLowerCase().includes(search.toLowerCase())
                )
                .map(renderLayerRow)}
                
          </div>
          
        ))
        
      ) : (
        layers
          .filter((layer) =>
            layer.layer_name.toLowerCase().includes(search.toLowerCase())
          )
          .map(renderLayerRow)
      )} */}
      {grouped ? (
  Object.entries(groupedLayers).map(([groupName, groupLayers], index) => {
    // 🔽 filter groupLayers based on used/all toggle
    const filtered = (showUsedOnly ? groupLayers.filter(l => layerLibrary.getUsedLayers().includes(l)) : groupLayers)
      .filter(l => l.layer_name.toLowerCase().includes(search.toLowerCase()));

    if (filtered.length === 0) return null;

    return (
      <div key={index} style={{ marginBottom: '10px' }}>
        <div
          onClick={() => toggleGroup(groupName)}
          style={{
            backgroundColor: '#333',
            padding: '10px',
            cursor: 'pointer',
            fontWeight: 'bold',
            borderRadius: '6px 6px 0 0',
            userSelect: 'none',
          }}
        >
          {expandedGroups[groupName] ? '▼' : '▶'} {groupName}
        </div>

        {expandedGroups[groupName] && filtered.map(renderLayerRow)}
      </div>
    );
  })
) : (
  (showUsedOnly ? layerLibrary.getUsedLayers() : layers)
    .filter(l => l.layer_name.toLowerCase().includes(search.toLowerCase()))
    .map(renderLayerRow)
)}

      </div>
      {showModal && (
  <NewLayerModal
    onClose={() => setShowModal(false)}
    onSave={handleSaveLayer}
  />
)}

    </div>
    
  );
};

const iconBarStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '1px',
  marginBottom: '0px',
  overflowX: 'auto',
  paddingBottom: '2px',
  alignItems: 'center',   // ✅ keeps buttons, color picker & range aligned
};

const searchStyle = {
  padding: '3px',
  borderRadius: '4px',
  border: '1px solid #555',
  backgroundColor: '#222',
  color: '#fff',
  width: '94%',
  marginBottom: '4px',
  margintop: '0px',
};

const layerBoxStyle = {
  display: 'flex',
  alignItems: 'flex-start',
  backgroundColor: '#2b2b2b',
  padding: '0px 0px',
  margin: '0px 0',
  borderBottom: '1px solid #444',
};

const inputStyle = {
    padding: '0 2px',              // remove vertical padding
    fontSize: '11px',
    height: '20px',                // tighter height
    lineHeight: '20px',            // align text vertically
    borderRadius: '4px',
    border: '1px solid #555',
    backgroundColor: '#1f1f1f',
    color: '#fff',
    width: '100%',
    boxSizing: 'border-box',
  };
  


  // Truncate text to a specific length and add ellipsis
const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + '...';
    }
    return text;
  };
  
  

export default LayerTab;
